<template>
  <div class="face-recognition-result">
    <div class="result-inner">
      <div class="face-image">
        <img v-if="faceUrl" :src="faceUrl" :alt="personName || ''" />
        <div v-else class="placeholder"></div>
        <div
          class="indicator"
          :class="{ success: isVerified, warning: !isVerified }"
          aria-hidden="true"
        >
          <svg-icon :name="isVerified ? 'success' : 'warning'" />
        </div>
      </div>

      <h1 class="title">{{ title }}</h1>
      <p
        class="description"
        :class="{ 'text-red-500': !isVerified, 'text-green-500': isVerified }"
      >
        {{ description }}
      </p>

      <Button
        v-if="!isVerified"
        variant="outline"
        size="lg"
        class="action-btn"
        @click="retry"
      >
        {{ $t("Попробовать снова") }}
      </Button>
      <Button
        v-else
        variant="default"
        size="lg"
        class="action-btn"
        @click="loginNow"
      >
        {{ $t("Войти") }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/shared/ui/button/Button.vue";

export default {
  name: "FaceIdResult",
  components: { Button },
  props: {
    faceUrl: { type: String, default: null },
    result: { type: Boolean, required: true },
    personName: { type: String, default: "" },
    errorMessage: { type: String, default: "" },
    autoLoginDelayMs: { type: Number, default: 3000 },
  },
  emits: ["retry", "login"],

  data() {
    return {
      autoLoginTimer: null,
    };
  },

  computed: {
    isVerified() {
      return this.result;
    },
    title() {
      return this.isVerified
        ? this.personName || this.$t("Успешно")
        : this.$t("Идентификация не прошла");
    },
    description() {
      if (this.isVerified) {
        return this.$t("Вы успешно прошли идентификацию");
      }
      return this.errorMessage || this.$t("Вы не прошли идентификацию");
    },
  },

  mounted() {
    if (this.isVerified) {
      this.autoLoginTimer = setTimeout(() => {
        this.$emit("login");
      }, this.autoLoginDelayMs);
    }
  },

  beforeUnmount() {
    if (this.autoLoginTimer) clearTimeout(this.autoLoginTimer);
  },

  methods: {
    retry() {
      if (this.autoLoginTimer) {
        clearTimeout(this.autoLoginTimer);
        this.autoLoginTimer = null;
      }
      this.$emit("retry");
    },
    loginNow() {
      if (this.autoLoginTimer) {
        clearTimeout(this.autoLoginTimer);
        this.autoLoginTimer = null;
      }
      this.$emit("login");
    },
  },
};
</script>

<style lang="scss" scoped>
.face-recognition-result {
  @apply w-full h-full flex items-center justify-center px-6;
}

.result-inner {
  @apply flex flex-col items-center w-full max-w-sm;
}

.face-image {
  @apply relative w-32 h-32;

  img,
  .placeholder {
    @apply w-full h-full object-cover rounded-full overflow-hidden bg-gray-100;
  }
}

.indicator {
  @apply absolute bottom-0 right-0 flex items-center justify-center w-8 h-8 rounded-full;
  border: 2px solid #fff;

  svg {
    @apply fill-none w-4 h-4;
  }

  &.success {
    @apply bg-green-200 text-green-500;
  }

  &.warning {
    @apply bg-red-200 text-red-500;
  }
}

.title {
  @apply mt-5 mb-0 text-2xl font-semibold text-center;
  color: hsl(var(--foreground));
}

.description {
  @apply mt-1 text-sm text-center;
}

.action-btn {
  @apply mt-10 w-full font-normal;
}
</style>
